import setPromiseState from '../../utils/promiseState';
import {getLocalStorage, setLocalStorage} from '../../utils/storage';

const getCartFromStorage = () => {
  const data = getLocalStorage('cart');
  // Check Storage
  const c = JSON.parse(data);
  if (c && c.length)
    for (let i = 0; i < c.length; i++) {
      if (c[i] && !c[i].id) {
        setLocalStorage('cart', []);
        return [];
      }
    }
  if (data)
    return JSON.parse(data);
  return []
};

const getMetingPlace = () => {
  const data = getLocalStorage('cart_meting_place');
  if (data) {
    return JSON.parse(data);
  }
  return null;
};

export default {
  list: getCartFromStorage(),
  toursList: [],
  metingPlace: getMetingPlace(),
  promise: {
    getCartTours: setPromiseState()
  },
  error: {}
}


// WEBPACK FOOTER //
// ./src/app/containers/Cart/InitState.js